import React, { Component } from 'react';
import { Trans, translate } from 'react-i18next';
// import { Link } from 'react-router-dom';

function getDurationString(duration) {
    switch (duration) {
        case '4':
            return {
                key: 'hrs_2',
                number: 2
            };
        case '8':
            return {
                key: 'hrs_4',
                number: 4
            };
        case '9':
            return {
                key: 'full_day',
                number: 8
            };
        default:
            return 0;
    }
}

function getTypeSalaString(tipo_sala) {
    const types = {
        Chica: 'type_small',
        Mediana: 'type_medium',
        Grande: 'type_large'
    }

    return types[tipo_sala] || 'type_large';
}

class CardRoom extends Component {
    handleClick(event, room) {
        event.stopPropagation();
        this.props.handleBookRoom(room.id)
    }

    render() {
        const rooms = this.props.rooms;
        const duration = this.props.duration;
        const durationString = getDurationString(duration);
        return (
            <div className="list-card-resvations" >
                <div className="list-card-panel-seccion">
                    <div className="content-card-panel-seccion">
                        <div className="row list list2">
                            {rooms.map((room, index) => (
                                <div className="col-lg-6 col-md-6 col-sm-12 col-12 card-panel-rooms" key={index} onClick={() => this.props.handleBookRoomPlus(room.id)}>
                                    <div className="card-panel panel panel-default card">
                                        <div className="panel-heading" style={{ backgroundImage: "url('" + room.imagen + "')" }}>
                                        </div>
                                        <div className="card-panel-body">
                                            <div className="panel-body-title">
                                                <h4 className="ioscentro">{room.name.toUpperCase()}</h4>
                                            </div>
                                            <div className="panel-body-description">
                                                <div className="panel-description-text">
                                                    {room.descripcion.slice(0, 150)}{room.descripcion.length > 150 ? '...' : null}
                                                </div>
                                                <div className="panel-description-information">
                                                    <div className="contenedor-flexbox">
                                                        <div className="contenedor">
                                                            <i className="fa fa-users" aria-hidden="true">
                                                            </i>
                                                            <Trans
                                                                i18nKey="dashboard.reservations.capacity"
                                                            >
                                                                Capacidad para {{ count: room.capacidad }} personas
                                                            </Trans>
                                                        </div>
                                                    </div>
                                                    <div className="contenedor-flexbox">
                                                        <div className="contenedor">
                                                            <i className="fa fa-usd" aria-hidden="true"></i>
                                                            <Trans i18nKey='dashboard.reservations.price_capacity'>
                                                                {{
                                                                    count: durationString.number,
                                                                    price: room[durationString.key]
                                                                }}
                                                            </Trans>
                                                            {/* {duration === '4' ? (
                                                                "Precio de Sala por 2 Horas $" + room.hrs_2
                                                            ) : (
                                                                duration === '8' ? (
                                                                    "Precio de Sala por 4 Horas $" + room.hrs_4
                                                                ) : (
                                                                    "Precio de Sala por un dia Completo $" + room.full_day
                                                                )
                                                            )} */}

                                                        </div>
                                                    </div>
                                                    <div className="contenedor-flexbox">
                                                        <div className="contenedor">
                                                            <i className="fa-solid fa-up-right-and-down-left-from-center"></i> 
                                                            {" "}
                                                            <Trans>venta_linea.index.sala.type</Trans>
                                                            {" "}
                                                            <Trans>venta_linea.index.sala.{getTypeSalaString(
                                                                room.tipo_sala
                                                            )}</Trans>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel-body-bottom">
                                                <div className="form-group">
                                                    <button
                                                        onClick={(e) => this.handleClick(e, room)}
                                                        className="btn btn-block btn-primary"
                                                        type="button">
                                                        <Trans>venta_linea.index.sala.reserve</Trans>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(CardRoom);


// WEBPACK FOOTER //
// ./src/store/Reservation/CardRoom.js